import { ProductSortType } from '@/types';

export const DEFAULT_MAX_PRICE_FILTER = 1000000;

export const DEFAULT_COOKIE_OPTIONS = {
  httpOnly: true,
  sameSite: 'lax',
  path: '/',
  secure: process.env.NODE_ENV === 'production',
  maxAge: 60 * 60 * 24 * 30,
};

export const paymentMethodList = [
  { image: '/assets/img/cod.svg', name: 'cash_on_delivery' },
  { image: '/assets/img/vodafone.svg', name: 'vodafone_cash' },
  { image: '/assets/img/instapay.svg', name: 'instapay' },
];

export const sortingValues: ProductSortType[] = [
  'best_selling',
  'price_low_high',
  'price_high_low',
  'discount_low_high',
  'discount_high_low',
  'newest',
  'oldest',
];

export const profileTabs = [
  {
    title: 'general',
    link: 'general',
    icon: 'icon-user',
  },
  {
    title: 'change_phone_number',
    link: 'edit-phone-number',
    icon: 'icon-phone',
  },
  {
    title: 'change_password',
    link: 'edit-password',
    icon: 'icon-lock',
  },
  {
    title: 'orders',
    link: 'orders',
    icon: 'icon-bag2',
  },

  {
    title: 'shipping_addresses',
    link: 'shipping-addresses',
    icon: 'icon-map-marker',
  },
  {
    title: 'wishlist',
    link: 'wishlist',
    icon: 'icon-heart',
  },
  {
    title: 'discount_coupons',
    link: 'discount-coupons',
    icon: 'icon-gift',
  },
  {
    title: 'notifications',
    link: 'notifications',
    icon: 'fa fa-bell-o',
  },
];



export const currencyLocales = {
  ar: 'ar-EG', // Arabic - Egypt
  de: 'de-DE', // German - Germany
  en: 'en-US', // English - United States
  es: 'es-ES', // Spanish - Spain
  fr: 'fr-FR', // French - France
  it: 'it-IT', // Italian - Italy
  ja: 'ja-JP', // Japanese - Japan
  nl: 'nl-NL', // Dutch - Netherlands
  pt: 'pt-PT', // Portuguese - Portugal
  ru: 'ru-RU', // Russian - Russia
  tr: 'tr-TR', // Turkish - Turkey
  zh: 'zh-CN', // Chinese - China (Simplified)
};
